/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WithdrawalIndexRouteImport } from './routes/withdrawal.index'
import { Route as WithdrawalFundsRouteImport } from './routes/withdrawal.funds'
import { Route as ProtectedDriverRechargeRouteImport } from './routes/_protected.driver-recharge'
import { Route as ProtectedWithdrawalSmzIndexRouteImport } from './routes/_protected.withdrawal-smz.index'
import { Route as ProtectedPassCardBindIndexRouteImport } from './routes/_protected.pass-card-bind.index'
import { Route as ProtectedDriverRechargeIndexRouteImport } from './routes/_protected.driver-recharge.index'
import { Route as ProtectedWithdrawalSmzFormRouteImport } from './routes/_protected.withdrawal-smz.form'
import { Route as ProtectedPassCardBindSuccessRouteImport } from './routes/_protected.pass-card-bind.success'
import { Route as ProtectedPassCardBindErrorRouteImport } from './routes/_protected.pass-card-bind.error'
import { Route as ProtectedDriverRechargeSuccessRouteImport } from './routes/_protected.driver-recharge.success'
import { Route as ProtectedDriverRechargeErrorRouteImport } from './routes/_protected.driver-recharge.error'
import { Route as ProtectedWithdrawalSmzResultIndexRouteImport } from './routes/_protected.withdrawal-smz.result.index'
import { Route as ProtectedWithdrawalSmzAccountLinkIndexRouteImport } from './routes/_protected.withdrawal-smz.account-link.index'

const RedirectRoute = RedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WithdrawalIndexRoute = WithdrawalIndexRouteImport.update({
  id: '/withdrawal/',
  path: '/withdrawal/',
  getParentRoute: () => rootRouteImport,
} as any)
const WithdrawalFundsRoute = WithdrawalFundsRouteImport.update({
  id: '/withdrawal/funds',
  path: '/withdrawal/funds',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedDriverRechargeRoute = ProtectedDriverRechargeRouteImport.update({
  id: '/driver-recharge',
  path: '/driver-recharge',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWithdrawalSmzIndexRoute =
  ProtectedWithdrawalSmzIndexRouteImport.update({
    id: '/withdrawal-smz/',
    path: '/withdrawal-smz/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedPassCardBindIndexRoute =
  ProtectedPassCardBindIndexRouteImport.update({
    id: '/pass-card-bind/',
    path: '/pass-card-bind/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDriverRechargeIndexRoute =
  ProtectedDriverRechargeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDriverRechargeRoute,
  } as any)
const ProtectedWithdrawalSmzFormRoute =
  ProtectedWithdrawalSmzFormRouteImport.update({
    id: '/withdrawal-smz/form',
    path: '/withdrawal-smz/form',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedPassCardBindSuccessRoute =
  ProtectedPassCardBindSuccessRouteImport.update({
    id: '/pass-card-bind/success',
    path: '/pass-card-bind/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedPassCardBindErrorRoute =
  ProtectedPassCardBindErrorRouteImport.update({
    id: '/pass-card-bind/error',
    path: '/pass-card-bind/error',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDriverRechargeSuccessRoute =
  ProtectedDriverRechargeSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => ProtectedDriverRechargeRoute,
  } as any)
const ProtectedDriverRechargeErrorRoute =
  ProtectedDriverRechargeErrorRouteImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => ProtectedDriverRechargeRoute,
  } as any)
const ProtectedWithdrawalSmzResultIndexRoute =
  ProtectedWithdrawalSmzResultIndexRouteImport.update({
    id: '/withdrawal-smz/result/',
    path: '/withdrawal-smz/result/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWithdrawalSmzAccountLinkIndexRoute =
  ProtectedWithdrawalSmzAccountLinkIndexRouteImport.update({
    id: '/withdrawal-smz/account-link/',
    path: '/withdrawal-smz/account-link/',
    getParentRoute: () => ProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/redirect': typeof RedirectRoute
  '/driver-recharge': typeof ProtectedDriverRechargeRouteWithChildren
  '/withdrawal/funds': typeof WithdrawalFundsRoute
  '/withdrawal/': typeof WithdrawalIndexRoute
  '/driver-recharge/error': typeof ProtectedDriverRechargeErrorRoute
  '/driver-recharge/success': typeof ProtectedDriverRechargeSuccessRoute
  '/pass-card-bind/error': typeof ProtectedPassCardBindErrorRoute
  '/pass-card-bind/success': typeof ProtectedPassCardBindSuccessRoute
  '/withdrawal-smz/form': typeof ProtectedWithdrawalSmzFormRoute
  '/driver-recharge/': typeof ProtectedDriverRechargeIndexRoute
  '/pass-card-bind/': typeof ProtectedPassCardBindIndexRoute
  '/withdrawal-smz/': typeof ProtectedWithdrawalSmzIndexRoute
  '/withdrawal-smz/account-link/': typeof ProtectedWithdrawalSmzAccountLinkIndexRoute
  '/withdrawal-smz/result/': typeof ProtectedWithdrawalSmzResultIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/redirect': typeof RedirectRoute
  '/withdrawal/funds': typeof WithdrawalFundsRoute
  '/withdrawal': typeof WithdrawalIndexRoute
  '/driver-recharge/error': typeof ProtectedDriverRechargeErrorRoute
  '/driver-recharge/success': typeof ProtectedDriverRechargeSuccessRoute
  '/pass-card-bind/error': typeof ProtectedPassCardBindErrorRoute
  '/pass-card-bind/success': typeof ProtectedPassCardBindSuccessRoute
  '/withdrawal-smz/form': typeof ProtectedWithdrawalSmzFormRoute
  '/driver-recharge': typeof ProtectedDriverRechargeIndexRoute
  '/pass-card-bind': typeof ProtectedPassCardBindIndexRoute
  '/withdrawal-smz': typeof ProtectedWithdrawalSmzIndexRoute
  '/withdrawal-smz/account-link': typeof ProtectedWithdrawalSmzAccountLinkIndexRoute
  '/withdrawal-smz/result': typeof ProtectedWithdrawalSmzResultIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/error': typeof ErrorRoute
  '/redirect': typeof RedirectRoute
  '/_protected/driver-recharge': typeof ProtectedDriverRechargeRouteWithChildren
  '/withdrawal/funds': typeof WithdrawalFundsRoute
  '/withdrawal/': typeof WithdrawalIndexRoute
  '/_protected/driver-recharge/error': typeof ProtectedDriverRechargeErrorRoute
  '/_protected/driver-recharge/success': typeof ProtectedDriverRechargeSuccessRoute
  '/_protected/pass-card-bind/error': typeof ProtectedPassCardBindErrorRoute
  '/_protected/pass-card-bind/success': typeof ProtectedPassCardBindSuccessRoute
  '/_protected/withdrawal-smz/form': typeof ProtectedWithdrawalSmzFormRoute
  '/_protected/driver-recharge/': typeof ProtectedDriverRechargeIndexRoute
  '/_protected/pass-card-bind/': typeof ProtectedPassCardBindIndexRoute
  '/_protected/withdrawal-smz/': typeof ProtectedWithdrawalSmzIndexRoute
  '/_protected/withdrawal-smz/account-link/': typeof ProtectedWithdrawalSmzAccountLinkIndexRoute
  '/_protected/withdrawal-smz/result/': typeof ProtectedWithdrawalSmzResultIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/redirect'
    | '/driver-recharge'
    | '/withdrawal/funds'
    | '/withdrawal/'
    | '/driver-recharge/error'
    | '/driver-recharge/success'
    | '/pass-card-bind/error'
    | '/pass-card-bind/success'
    | '/withdrawal-smz/form'
    | '/driver-recharge/'
    | '/pass-card-bind/'
    | '/withdrawal-smz/'
    | '/withdrawal-smz/account-link/'
    | '/withdrawal-smz/result/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/redirect'
    | '/withdrawal/funds'
    | '/withdrawal'
    | '/driver-recharge/error'
    | '/driver-recharge/success'
    | '/pass-card-bind/error'
    | '/pass-card-bind/success'
    | '/withdrawal-smz/form'
    | '/driver-recharge'
    | '/pass-card-bind'
    | '/withdrawal-smz'
    | '/withdrawal-smz/account-link'
    | '/withdrawal-smz/result'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/error'
    | '/redirect'
    | '/_protected/driver-recharge'
    | '/withdrawal/funds'
    | '/withdrawal/'
    | '/_protected/driver-recharge/error'
    | '/_protected/driver-recharge/success'
    | '/_protected/pass-card-bind/error'
    | '/_protected/pass-card-bind/success'
    | '/_protected/withdrawal-smz/form'
    | '/_protected/driver-recharge/'
    | '/_protected/pass-card-bind/'
    | '/_protected/withdrawal-smz/'
    | '/_protected/withdrawal-smz/account-link/'
    | '/_protected/withdrawal-smz/result/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  RedirectRoute: typeof RedirectRoute
  WithdrawalFundsRoute: typeof WithdrawalFundsRoute
  WithdrawalIndexRoute: typeof WithdrawalIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/redirect': {
      id: '/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof RedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/withdrawal/': {
      id: '/withdrawal/'
      path: '/withdrawal'
      fullPath: '/withdrawal/'
      preLoaderRoute: typeof WithdrawalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/withdrawal/funds': {
      id: '/withdrawal/funds'
      path: '/withdrawal/funds'
      fullPath: '/withdrawal/funds'
      preLoaderRoute: typeof WithdrawalFundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/driver-recharge': {
      id: '/_protected/driver-recharge'
      path: '/driver-recharge'
      fullPath: '/driver-recharge'
      preLoaderRoute: typeof ProtectedDriverRechargeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal-smz/': {
      id: '/_protected/withdrawal-smz/'
      path: '/withdrawal-smz'
      fullPath: '/withdrawal-smz/'
      preLoaderRoute: typeof ProtectedWithdrawalSmzIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pass-card-bind/': {
      id: '/_protected/pass-card-bind/'
      path: '/pass-card-bind'
      fullPath: '/pass-card-bind/'
      preLoaderRoute: typeof ProtectedPassCardBindIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/driver-recharge/': {
      id: '/_protected/driver-recharge/'
      path: '/'
      fullPath: '/driver-recharge/'
      preLoaderRoute: typeof ProtectedDriverRechargeIndexRouteImport
      parentRoute: typeof ProtectedDriverRechargeRoute
    }
    '/_protected/withdrawal-smz/form': {
      id: '/_protected/withdrawal-smz/form'
      path: '/withdrawal-smz/form'
      fullPath: '/withdrawal-smz/form'
      preLoaderRoute: typeof ProtectedWithdrawalSmzFormRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pass-card-bind/success': {
      id: '/_protected/pass-card-bind/success'
      path: '/pass-card-bind/success'
      fullPath: '/pass-card-bind/success'
      preLoaderRoute: typeof ProtectedPassCardBindSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pass-card-bind/error': {
      id: '/_protected/pass-card-bind/error'
      path: '/pass-card-bind/error'
      fullPath: '/pass-card-bind/error'
      preLoaderRoute: typeof ProtectedPassCardBindErrorRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/driver-recharge/success': {
      id: '/_protected/driver-recharge/success'
      path: '/success'
      fullPath: '/driver-recharge/success'
      preLoaderRoute: typeof ProtectedDriverRechargeSuccessRouteImport
      parentRoute: typeof ProtectedDriverRechargeRoute
    }
    '/_protected/driver-recharge/error': {
      id: '/_protected/driver-recharge/error'
      path: '/error'
      fullPath: '/driver-recharge/error'
      preLoaderRoute: typeof ProtectedDriverRechargeErrorRouteImport
      parentRoute: typeof ProtectedDriverRechargeRoute
    }
    '/_protected/withdrawal-smz/result/': {
      id: '/_protected/withdrawal-smz/result/'
      path: '/withdrawal-smz/result'
      fullPath: '/withdrawal-smz/result/'
      preLoaderRoute: typeof ProtectedWithdrawalSmzResultIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal-smz/account-link/': {
      id: '/_protected/withdrawal-smz/account-link/'
      path: '/withdrawal-smz/account-link'
      fullPath: '/withdrawal-smz/account-link/'
      preLoaderRoute: typeof ProtectedWithdrawalSmzAccountLinkIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedDriverRechargeRouteChildren {
  ProtectedDriverRechargeErrorRoute: typeof ProtectedDriverRechargeErrorRoute
  ProtectedDriverRechargeSuccessRoute: typeof ProtectedDriverRechargeSuccessRoute
  ProtectedDriverRechargeIndexRoute: typeof ProtectedDriverRechargeIndexRoute
}

const ProtectedDriverRechargeRouteChildren: ProtectedDriverRechargeRouteChildren =
  {
    ProtectedDriverRechargeErrorRoute: ProtectedDriverRechargeErrorRoute,
    ProtectedDriverRechargeSuccessRoute: ProtectedDriverRechargeSuccessRoute,
    ProtectedDriverRechargeIndexRoute: ProtectedDriverRechargeIndexRoute,
  }

const ProtectedDriverRechargeRouteWithChildren =
  ProtectedDriverRechargeRoute._addFileChildren(
    ProtectedDriverRechargeRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedDriverRechargeRoute: typeof ProtectedDriverRechargeRouteWithChildren
  ProtectedPassCardBindErrorRoute: typeof ProtectedPassCardBindErrorRoute
  ProtectedPassCardBindSuccessRoute: typeof ProtectedPassCardBindSuccessRoute
  ProtectedWithdrawalSmzFormRoute: typeof ProtectedWithdrawalSmzFormRoute
  ProtectedPassCardBindIndexRoute: typeof ProtectedPassCardBindIndexRoute
  ProtectedWithdrawalSmzIndexRoute: typeof ProtectedWithdrawalSmzIndexRoute
  ProtectedWithdrawalSmzAccountLinkIndexRoute: typeof ProtectedWithdrawalSmzAccountLinkIndexRoute
  ProtectedWithdrawalSmzResultIndexRoute: typeof ProtectedWithdrawalSmzResultIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDriverRechargeRoute: ProtectedDriverRechargeRouteWithChildren,
  ProtectedPassCardBindErrorRoute: ProtectedPassCardBindErrorRoute,
  ProtectedPassCardBindSuccessRoute: ProtectedPassCardBindSuccessRoute,
  ProtectedWithdrawalSmzFormRoute: ProtectedWithdrawalSmzFormRoute,
  ProtectedPassCardBindIndexRoute: ProtectedPassCardBindIndexRoute,
  ProtectedWithdrawalSmzIndexRoute: ProtectedWithdrawalSmzIndexRoute,
  ProtectedWithdrawalSmzAccountLinkIndexRoute:
    ProtectedWithdrawalSmzAccountLinkIndexRoute,
  ProtectedWithdrawalSmzResultIndexRoute:
    ProtectedWithdrawalSmzResultIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  ErrorRoute: ErrorRoute,
  RedirectRoute: RedirectRoute,
  WithdrawalFundsRoute: WithdrawalFundsRoute,
  WithdrawalIndexRoute: WithdrawalIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
